import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ShipmentItemCard } from "./ShipmentItem";
import { PlacedShipmentCard } from "./PlacedShipmentCard";

export const ProcessInboundShipmentCard = ({ classes, match, history }) => {
  const dispatchRa = useDispatch();
  const shipmentId = match?.params?.id;
  const lastSelectedAisle = useSelector(
    (state) => state.data.lastSelectedAisle,
  );

  useEffect(() => {
    const lastUsedShipmentId = lastSelectedAisle?.shipmentId;
    if (!lastUsedShipmentId || lastUsedShipmentId === shipmentId) {
      return;
    }
    // Reset aisle memory only when entering a shipment context.
    // Keeps aisle memory while switching inventories/add-location inside same shipment.
    dispatchRa({
      type: "SET_LAST_SELECTED_AISLE",
      payload: { aisle: null, shipmentId: null },
    });
  }, [dispatchRa, shipmentId, lastSelectedAisle]);

  return (
    <>
      <Route
        path={`${match.path}/inventories/:id`}
        render={(props) => <ShipmentItemCard {...props} />}
      />
      <Route
        path={`${match.path}`}
        exact
        render={(props) => (
          <PlacedShipmentCard classes={classes} history={history} {...props} />
        )}
      />
    </>
  );
};
